module.exports = __webpack_public_path__ + "static/media/recommendation1.d9d50ecd.png";